export default __webpack_public_path__ + "static/media/not-found-page.f4f33d20.svg";